<div matDialogTitle>Oszczędzaj na rachunkach</div>

<div class="flex flex-col">
  <div class="flex flex-col justify-center items-center">
    <img src="/assets/images/offers/dobry-prad-discount.svg" />
  </div>

  <div class="mt-44">
    Zajmujesz się rachunkami w domu jednorodzinnym? Chcesz oszczędzać, być eko i zdobyć niezależność?
  </div>
  <div class="mt-20">
    Sprawdź ofertę fotowoltaiki przygotowaną specjalnie dla Ciebie i
    <strong>oszczędzaj nawet 3000&nbsp;zł rocznie!</strong>
  </div>
</div>

<mat-dialog-actions align="start">
  <button color="primary" mat-raised-button (click)="showOffer()">Zobacz ofertę</button>
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
